
import React from 'react';
import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import LogoutButton from './LogoutButton';
import MessagesNotification from './MessagesNotification';

interface DesktopHeaderProps {
  onToggleSidebar: () => void;
}

const DesktopHeader: React.FC<DesktopHeaderProps> = ({ onToggleSidebar }) => {
  return (
    <div className="sticky top-0 z-50 border-b bg-background/80 backdrop-blur-sm p-4 flex justify-between items-center">
      <Button 
        variant="ghost" 
        size="sm" 
        onClick={onToggleSidebar}
        className="h-10 w-10 p-0"
      >
        <Menu className="h-6 w-6" />
      </Button>
      
      <div className="flex items-center gap-2">
        <MessagesNotification />
        <LogoutButton variant="desktop" />
      </div>
    </div>
  );
};

export default DesktopHeader;
